export const css = {
    titleBlock: '_27w5i7Uy',
    ' _key': 'ascm-theme/ascm/quiz-widgets/quizfolder'
};
export default css;
